import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./utilities/customHooks/auth";
import {AppProvider} from "./utilities/contexts/app-context";
import {RegistryProvider} from "./utilities/contexts/registry-context";

ReactDOM.render(
    <React.StrictMode>
        <AppProvider>
            <RegistryProvider>
                <App/>
            </RegistryProvider>
        </AppProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
